import { render, staticRenderFns } from "./UserSign.vue?vue&type=template&id=8aedd776&scoped=true&"
import script from "./UserSign.vue?vue&type=script&lang=js&"
export * from "./UserSign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aedd776",
  null
  
)

export default component.exports